import "@/App.css";
import "@/crm-theme.css";
import "@/crm-shell.css";
import "@/crm-accents.css";
import "@/crm-gold.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ReservationForm from "@/pages/ReservationForm";
import ReservationDetail from "@/pages/ReservationDetail";
import ViewingDetail from "@/pages/ViewingDetail";
import BatchPrint from "@/pages/BatchPrint";
import Crew from "@/pages/Crew";
import Settings from "@/pages/Settings";
import SlabImport from "@/pages/SlabImport";
import SinkImport from "@/pages/SinkImport";
import AiDataImport from "@/pages/AiDataImport";
import SavedImportLayouts from "@/pages/SavedImportLayouts";
import PricingSettings from "@/pages/PricingSettings";
import TwilioSettings from "@/pages/TwilioSettings";
import EmailTemplates from "@/pages/EmailTemplates";
import EmailDesign from "@/pages/EmailDesign";
import Integrations from "@/pages/Integrations";
import AiImagesSettings from "@/pages/AiImagesSettings";
import AiAssistantSettings from "@/pages/AiAssistantSettings";
import ShopAssistant from "@/pages/ShopAssistant";
import MediaLibrary from "@/pages/MediaLibrary";
import AiImport from "@/pages/AiImport";
import Quotes from "@/pages/Quotes";
import { RequirePerm } from "@/components/RequirePerm";
import QuoteBuilder from "@/pages/QuoteBuilder";
import QuoteTemplateSettings from "@/pages/QuoteTemplateSettings";
import DocumentTemplatesSettings from "@/pages/DocumentTemplatesSettings";
import QuoteLayout from "@/pages/QuoteLayout";
import VeinMatch from "@/pages/VeinMatch";
import DesignStudio from "@/pages/DesignStudio";
import DesignStudioPicker from "@/pages/DesignStudioPicker";
import Inventory from "@/pages/Inventory";
import RemnantForm from "@/pages/RemnantForm";
import RemnantDetail from "@/pages/RemnantDetail";
import SlabsInventory from "@/pages/SlabsInventory";
import CabinetryInventory from "@/pages/CabinetryInventory";
import CabinetImport from "@/pages/CabinetImport";
import SlabForm from "@/pages/SlabForm";
import SlabDetail from "@/pages/SlabDetail";
import Customers from "@/pages/Customers";
import Inbox from "@/pages/Inbox";
import CustomerForm from "@/pages/CustomerForm";
import CustomerDetail from "@/pages/CustomerDetail";
import InventoryReport from "@/pages/InventoryReport";
import JobBoard from "@/pages/JobBoard";
import JobForm from "@/pages/JobForm";
import JobDetail from "@/pages/JobDetail";
import JobPacket from "@/pages/JobPacket";
import JobSchedule from "@/pages/JobSchedule";
import TeamLoad from "@/pages/TeamLoad";
import CrewDaySheet from "@/pages/CrewDaySheet";
import MyDay from "@/pages/MyDay";
import MobileShell from "@/pages/mobile/MobileShell";
import MobileCalendar from "@/pages/mobile/MobileCalendar";
import MobileMyDay from "@/pages/mobile/MobileMyDay";
import MobileMap from "@/pages/mobile/MobileMap";
import MobileBills from "@/pages/mobile/MobileBills";
import MobileAccounts from "@/pages/mobile/MobileAccounts";
import MobileSettings from "@/pages/mobile/MobileSettings";
import MobileStock from "@/pages/mobile/MobileStock";
import MobileJob from "@/pages/mobile/MobileJob";
import MobileService from "@/pages/mobile/MobileService";
import MobileMessages from "@/pages/mobile/MobileMessages";
import CalendarView from "@/pages/CalendarView";
import RoutePlanner from "@/pages/RoutePlanner";
import Showroom from "@/pages/Showroom";
import CompletionPhotos from "@/pages/CompletionPhotos";
import SharePage from "@/pages/SharePage";
import PublicShowroom from "@/pages/PublicShowroom";
import PublicSlabDetail from "@/pages/PublicSlabDetail";
import PurchaseOrders from "@/pages/PurchaseOrders";
import Suppliers from "@/pages/Suppliers";
import SupplierForm from "@/pages/SupplierForm";
import SupplierDetail from "@/pages/SupplierDetail";
import Sinks from "@/pages/Sinks";
import SinkForm from "@/pages/SinkForm";
import SinkDetail from "@/pages/SinkDetail";
import RMAs from "@/pages/RMAs";
import RMAForm from "@/pages/RMAForm";
import RMADetail from "@/pages/RMADetail";
import PurchaseOrderForm from "@/pages/PurchaseOrderForm";
import PurchaseOrderDetail from "@/pages/PurchaseOrderDetail";
import Tasks from "@/pages/Tasks";
import ServiceCalls from "@/pages/ServiceCalls";
import ServiceCallForm from "@/pages/ServiceCallForm";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Leads from "@/pages/Leads";
import Pipeline from "@/pages/Pipeline";
import LeadDetail from "@/pages/LeadDetail";
import LeadForm from "@/pages/LeadForm";
import DrawingSettings from "@/pages/DrawingSettings";
import QuoteStages from "@/pages/QuoteStages";
import TaskTypesSettings from "@/pages/TaskTypesSettings";
import SlabOptionsSettings from "@/pages/SlabOptionsSettings";
import CommissionSettings from "@/pages/CommissionSettings";
import RateBandSettings from "@/pages/RateBandSettings";
import ScheduleAccessSettings from "@/pages/ScheduleAccessSettings";
import InstallLabelSettings from "@/pages/InstallLabelSettings";
import InstallLabel from "@/pages/InstallLabel";
import PortalSettings from "@/pages/PortalSettings";
import SiteSettings from "@/pages/SiteSettings";
import UserGroups from "@/pages/UserGroups";
import CompanySettings from "@/pages/CompanySettings";
import NeedsAPush from "@/pages/NeedsAPush";
import ProjectDetail from "@/pages/ProjectDetail";
import Invoices from "@/pages/Invoices";
import InvoiceDetail from "@/pages/InvoiceDetail";
import BillDetail from "@/pages/BillDetail";
import InvoicingSettings from "@/pages/InvoicingSettings";
import PaymentsSettings from "@/pages/PaymentsSettings";
import AppearanceSettings from "@/pages/AppearanceSettings";
import MicrosoftMailSettings from "@/pages/MicrosoftMailSettings";
import EmailActivity from "@/pages/EmailActivity";
import PortalInvoice from "@/pages/PortalInvoice";
import PortalPaymentReturn from "@/pages/PortalPaymentReturn";
import Account from "@/pages/Account";
import PortalLogin from "@/pages/PortalLogin";
import PortalEnter from "@/pages/PortalEnter";
import PortalHome from "@/pages/PortalHome";
import PortalList from "@/pages/PortalList";
import PortalInventory from "@/pages/PortalInventory";
import PortalReservations from "@/pages/PortalReservations";
import PortalInventoryItem from "@/pages/PortalInventoryItem";
import PortalSinks from "@/pages/PortalSinks";
import PortalSinkItem from "@/pages/PortalSinkItem";
import PortalRequestQuote from "@/pages/PortalRequestQuote";
import PublicCompare from "@/pages/PublicCompare";
import PortalProject from "@/pages/PortalProject";
import PortalQuote from "@/pages/PortalQuote";
import PortalJob from "@/pages/PortalJob";
import SiteHome from "@/pages/site/SiteHome";
import SiteServices from "@/pages/site/SiteServices";
import SiteTrade from "@/pages/site/SiteTrade";
import SiteDesigners from "@/pages/site/SiteDesigners";
import SiteContractors from "@/pages/site/SiteContractors";
import SiteEdges from "@/pages/site/SiteEdges";
import SiteBrand from "@/pages/site/SiteBrand";
import SiteBrandStock from "@/pages/site/SiteBrandStock";
import SupplierPoConfirm from "@/pages/site/SupplierPoConfirm";
import BookViewing from "@/pages/site/BookViewing";
import FixtureConfirm from "@/pages/site/FixtureConfirm";
import ColourChoice from "@/pages/site/ColourChoice";
import SiteGallery from "@/pages/site/SiteGallery";
import SiteProject from "@/pages/site/SiteProject";
import SiteAbout from "@/pages/site/SiteAbout";
import SiteContact from "@/pages/site/SiteContact";
import SiteResources from "@/pages/site/SiteResources";
import SiteTerms from "@/pages/site/SiteTerms";
import SitePrivacy from "@/pages/site/SitePrivacy";
import ShowroomDisplay from "@/pages/site/ShowroomDisplay";
import { useEffect } from "react";
import { setMeasureDefaults } from "@/lib/measure";

// Legacy CRM paths keep working: bounce them under /admin.
const CRM_SEGMENTS = [
  "account",
  "batch-print",
  "calendar",
  "completion-photos",
  "crew",
  "customers",
  "invoices",
  "jobs",
  "leads",
  "login",
  "new",
  "projects",
  "quotes",
  "reservation",
  "settings",
  "showroom",
  "tasks",
];

function AdminRedirect() {
  window.location.replace(
    `/admin${window.location.pathname}${window.location.search}`,
  );
  return null;
}

function LegacyItemRedirect() {
  const { key } = useParams();
  return <Navigate to={`/inventory/${key}`} replace />;
}

// Jobs now live on their project: /jobs/:id -> project page, Field work tab.
function JobsToProjects() {
  const loc = useLocation();
  const rest = loc.pathname.replace(/^\/jobs\/?/, "");
  const bareId = /^[0-9a-f]{24}$/i.test(rest);
  const search = bareId && !loc.search ? "?tab=field" : loc.search;
  return <Navigate to={`/projects${rest ? "/" + rest : ""}${search}${loc.hash}`} replace />;
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-10 w-10 animate-pulse rounded-md bg-yellow-500" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AuthedLogin() {
  const { user } = useAuth();
  if (user && user !== null) return <Navigate to="/" replace />;
  return <Login />;
}

function RoleHome() {
  const { user } = useAuth();
  const mode = localStorage.getItem("sw_mobile_mode");
  if (mode === "1") return <Navigate to="/mobile" replace />;
  if (user && user.role === "installer") {
    if (mode !== "0") return <Navigate to="/mobile" replace />;
    return <Navigate to="/jobs?tab=field" replace />;
  }
  return <Home />;
}

// Tape-measure display (fractions / precision) comes from Drawing settings and is public.
function MeasureDefaults() {
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/branding`)
      .then((r) => r.json())
      .then((d) => d?.measure && setMeasureDefaults(d.measure))
      .catch(() => {});
  }, []);
  return null;
}

export default function App() {
  if (!window.location.pathname.startsWith("/admin"))
    return (
      <>
        <MeasureDefaults />
        <PublicApp />
      </>
    );
  return (
    <div className="App dark crm" data-testid="crm-root">
      <MeasureDefaults />
      <BrowserRouter basename="/admin">
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<AuthedLogin />} />
            <Route
              path="/"
              element={
                <Protected>
                  <RoleHome />
                </Protected>
              }
            />
            <Route
              path="/completion-photos"
              element={
                <Protected>
                  <RequirePerm perm="read:showroom">
                    <CompletionPhotos />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/inventory/cabinetry"
              element={
                <Protected>
                  <RequirePerm perm="read:inventory">
                    <CabinetryInventory />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/inventory/cabinetry/import"
              element={
                <Protected>
                  <RequirePerm perm="read:inventory">
                    <CabinetImport />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/inventory/purchase-orders"
              element={
                <Protected>
                  <RequirePerm perm="read:purchasing">
                    <PurchaseOrders />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/inventory/suppliers"
              element={
                <Protected>
                  <RequirePerm perm="read:purchasing">
                    <Suppliers />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/inventory/suppliers/new"
              element={
                <Protected>
                  <SupplierForm />
                </Protected>
              }
            />
            <Route
              path="/inventory/suppliers/:id/edit"
              element={
                <Protected>
                  <SupplierForm />
                </Protected>
              }
            />
            <Route
              path="/inventory/suppliers/:id"
              element={
                <Protected>
                  <SupplierDetail />
                </Protected>
              }
            />
            <Route
              path="/inventory/sinks"
              element={
                <Protected>
                  <RequirePerm perm="read:inventory">
                    <Sinks />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/inventory/sinks/new"
              element={
                <Protected>
                  <SinkForm />
                </Protected>
              }
            />
            <Route
              path="/inventory/sinks/:id/edit"
              element={
                <Protected>
                  <SinkForm />
                </Protected>
              }
            />
            <Route
              path="/inventory/sinks/:id"
              element={
                <Protected>
                  <SinkDetail />
                </Protected>
              }
            />
            <Route
              path="/inventory/rmas"
              element={
                <Protected>
                  <RequirePerm perm="read:inventory">
                    <RMAs />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/inventory/rmas/new"
              element={
                <Protected>
                  <RMAForm />
                </Protected>
              }
            />
            <Route
              path="/inventory/rmas/:id/edit"
              element={
                <Protected>
                  <RMAForm />
                </Protected>
              }
            />
            <Route
              path="/inventory/rmas/:id"
              element={
                <Protected>
                  <RMADetail />
                </Protected>
              }
            />
            <Route
              path="/inventory/rmas"
              element={
                <Protected>
                  <RequirePerm perm="read:inventory">
                    <RMAs />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/inventory/rmas/new"
              element={
                <Protected>
                  <RMAForm />
                </Protected>
              }
            />
            <Route
              path="/inventory/rmas/:id/edit"
              element={
                <Protected>
                  <RMAForm />
                </Protected>
              }
            />
            <Route
              path="/inventory/rmas/:id"
              element={
                <Protected>
                  <RMADetail />
                </Protected>
              }
            />
            <Route
              path="/inventory/purchase-orders/new"
              element={
                <Protected>
                  <PurchaseOrderForm />
                </Protected>
              }
            />
            <Route
              path="/inventory/purchase-orders/:id"
              element={
                <Protected>
                  <PurchaseOrderDetail />
                </Protected>
              }
            />
            <Route
              path="/inventory/purchase-orders/:id/edit"
              element={
                <Protected>
                  <PurchaseOrderForm />
                </Protected>
              }
            />
            <Route
              path="/showroom"
              element={
                <Protected>
                  <RequirePerm perm="read:showroom">
                    <Showroom />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/route-planner"
              element={
                <Protected>
                  <RoutePlanner />
                </Protected>
              }
            />
            <Route
              path="/calendar"
              element={
                <Protected>
                  <CalendarView />
                </Protected>
              }
            />
            <Route
              path="/tasks"
              element={
                <Protected>
                  <Tasks />
                </Protected>
              }
            />
            <Route
              path="/inventory/material-on-hold"
              element={
                <Protected>
                  <Dashboard />
                </Protected>
              }
            />
            <Route
              path="/new"
              element={
                <Protected>
                  <ReservationForm />
                </Protected>
              }
            />
            <Route
              path="/reservation/:id"
              element={
                <Protected>
                  <ReservationDetail />
                </Protected>
              }
            />
            <Route
              path="/viewings/:id"
              element={
                <Protected>
                  <ViewingDetail />
                </Protected>
              }
            />
            <Route
              path="/reservation/:id/edit"
              element={
                <Protected>
                  <ReservationForm />
                </Protected>
              }
            />
            <Route
              path="/batch-print"
              element={
                <Protected>
                  <BatchPrint />
                </Protected>
              }
            />
            <Route
              path="/crew"
              element={
                <Protected>
                  <Crew />
                </Protected>
              }
            />
            <Route
              path="/settings"
              element={
                <Protected>
                  <Settings />
                </Protected>
              }
            />
            <Route
              path="/settings/import-slabs"
              element={
                <Protected>
                  <SlabImport />
                </Protected>
              }
            />
            <Route
              path="/settings/import-sinks"
              element={
                <Protected>
                  <SinkImport />
                </Protected>
              }
            />
            <Route
              path="/settings/import-customers"
              element={
                <Protected>
                  <AiDataImport entity="customers" />
                </Protected>
              }
            />
            <Route
              path="/settings/import-prices"
              element={
                <Protected>
                  <AiDataImport entity="slabs" />
                </Protected>
              }
            />
            <Route
              path="/settings/import-layouts"
              element={
                <Protected>
                  <SavedImportLayouts />
                </Protected>
              }
            />
            <Route
              path="/settings/pricing"
              element={
                <Protected>
                  <PricingSettings />
                </Protected>
              }
            />
            <Route
              path="/settings/task-types"
              element={
                <Protected>
                  <TaskTypesSettings />
                </Protected>
              }
            />
            <Route
              path="/settings/commissions"
              element={
                <Protected>
                  <CommissionSettings />
                </Protected>
              }
            />
            <Route
              path="/settings/slab-options"
              element={
                <Protected>
                  <SlabOptionsSettings />
                </Protected>
              }
            />
            <Route
              path="/settings/rate-bands"
              element={
                <Protected>
                  <RateBandSettings />
                </Protected>
              }
            />
            <Route
              path="/settings/schedule-access"
              element={
                <Protected>
                  <ScheduleAccessSettings />
                </Protected>
              }
            />
            <Route
              path="/settings/install-label"
              element={
                <Protected>
                  <InstallLabelSettings />
                </Protected>
              }
            />
            <Route
              path="/settings/texting"
              element={
                <Protected>
                  <TwilioSettings />
                </Protected>
              }
            />
            <Route
              path="/settings/quote-template"
              element={
                <Protected>
                  <QuoteTemplateSettings />
                </Protected>
              }
            />
            <Route
              path="/settings/document-templates"
              element={
                <Protected>
                  <DocumentTemplatesSettings />
                </Protected>
              }
            />
            <Route
              path="/settings/email"
              element={
                <Protected>
                  <EmailTemplates />
                </Protected>
              }
            />
            <Route
              path="/settings/email-design"
              element={
                <Protected>
                  <EmailDesign />
                </Protected>
              }
            />
            <Route
              path="/settings/integrations"
              element={
                <Protected>
                  <Integrations />
                </Protected>
              }
            />
            <Route
              path="/settings/ai-images"
              element={
                <Protected>
                  <AiImagesSettings />
                </Protected>
              }
            />
            <Route
              path="/settings/ai-assistant"
              element={
                <Protected>
                  <AiAssistantSettings />
                </Protected>
              }
            />
            <Route
              path="/settings/ai-import"
              element={
                <Protected>
                  <AiImport />
                </Protected>
              }
            />
            <Route
              path="/settings/media"
              element={
                <Protected>
                  <MediaLibrary />
                </Protected>
              }
            />
            <Route
              path="/assistant"
              element={
                <Protected>
                  <ShopAssistant />
                </Protected>
              }
            />
            <Route
              path="/quotes"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <Quotes />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/quotes/new"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <QuoteBuilder />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/quotes/:id"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <QuoteBuilder />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/quotes/:id/layout"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <QuoteLayout />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/quotes/:id/vein"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <VeinMatch />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/quotes/:id/design"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <DesignStudio />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/design"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <DesignStudioPicker />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/needs-a-push"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <NeedsAPush />
                  </RequirePerm>
                </Protected>
              }
            />

            <Route
              path="/projects/:id"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <ProjectDetail />
                  </RequirePerm>
                </Protected>
              }
            />

            <Route
              path="/invoices"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <Invoices />
                  </RequirePerm>
                </Protected>
              }
            />

            <Route
              path="/payables/bills/:id"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <BillDetail />
                  </RequirePerm>
                </Protected>
              }
            />

            <Route
              path="/invoices/:id"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <InvoiceDetail />
                  </RequirePerm>
                </Protected>
              }
            />

            <Route
              path="/settings/invoicing"
              element={
                <Protected>
                  <InvoicingSettings />
                </Protected>
              }
            />

            <Route
              path="/settings/payments"
              element={
                <Protected>
                  <PaymentsSettings />
                </Protected>
              }
            />

            <Route
              path="/settings/appearance"
              element={
                <Protected>
                  <AppearanceSettings />
                </Protected>
              }
            />

            <Route
              path="/settings/microsoft-mail"
              element={
                <Protected>
                  <MicrosoftMailSettings />
                </Protected>
              }
            />

            <Route
              path="/settings/email-activity"
              element={
                <Protected>
                  <EmailActivity />
                </Protected>
              }
            />

            <Route
              path="/settings/company"
              element={
                <Protected>
                  <RequirePerm perm="admin:settings">
                    <CompanySettings />
                  </RequirePerm>
                </Protected>
              }
            />

            <Route
              path="/settings/user-groups"
              element={
                <Protected>
                  <RequirePerm perm="admin:settings">
                    <UserGroups />
                  </RequirePerm>
                </Protected>
              }
            />

            <Route
              path="/settings/website"
              element={
                <Protected>
                  <RequirePerm perm="read:crew">
                    <SiteSettings />
                  </RequirePerm>
                </Protected>
              }
            />

            <Route
              path="/settings/portal"
              element={
                <Protected>
                  <RequirePerm perm="read:crew">
                    <PortalSettings />
                  </RequirePerm>
                </Protected>
              }
            />

            <Route
              path="/settings/quote-stages"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <QuoteStages />
                  </RequirePerm>
                </Protected>
              }
            />

            <Route
              path="/settings/drawing"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <DrawingSettings />
                  </RequirePerm>
                </Protected>
              }
            />

            <Route
              path="/leads/:id"
              element={
                <Protected>
                  <RequirePerm perm="read:accounts">
                    <LeadDetail />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/pipeline"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <Pipeline />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/leads"
              element={
                <Protected>
                  <RequirePerm perm="read:accounts">
                    <Leads />
                  </RequirePerm>
                </Protected>
              }
            />

            <Route
              path="/services"
              element={
                <Protected>
                  <RequirePerm perm="read:quotes">
                    <Services />
                  </RequirePerm>
                </Protected>
              }
            />

            <Route
              path="/inventory"
              element={<Navigate to="/inventory/material-on-hold" replace />}
            />
            <Route
              path="/inventory/slabs"
              element={
                <Protected>
                  <RequirePerm perm="read:inventory">
                    <SlabsInventory />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/inventory/slabs/new"
              element={
                <Protected>
                  <SlabForm />
                </Protected>
              }
            />
            <Route
              path="/inventory/slabs/:id"
              element={
                <Protected>
                  <SlabDetail />
                </Protected>
              }
            />
            <Route
              path="/inventory/slabs/:id/edit"
              element={
                <Protected>
                  <SlabForm />
                </Protected>
              }
            />
            <Route
              path="/inventory/remnants"
              element={
                <Protected>
                  <RequirePerm perm="read:inventory">
                    <Inventory />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/inventory/remnants/new"
              element={
                <Protected>
                  <RemnantForm />
                </Protected>
              }
            />
            <Route
              path="/inventory/remnants/:id"
              element={
                <Protected>
                  <RemnantDetail />
                </Protected>
              }
            />
            <Route
              path="/inventory/remnants/:id/edit"
              element={
                <Protected>
                  <RemnantForm />
                </Protected>
              }
            />
            <Route
              path="/customers"
              element={
                <Protected>
                  <RequirePerm perm="read:accounts">
                    <Customers />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/customers/new"
              element={
                <Protected>
                  <CustomerForm />
                </Protected>
              }
            />
            <Route
              path="/customers/:id"
              element={
                <Protected>
                  <CustomerDetail />
                </Protected>
              }
            />
            <Route
              path="/customers/:id/edit"
              element={
                <Protected>
                  <CustomerForm />
                </Protected>
              }
            />
            <Route
              path="/inventory/reporting"
              element={
                <Protected>
                  <InventoryReport />
                </Protected>
              }
            />
            <Route
              path="/projects"
              element={
                <Protected>
                  <RequirePerm perm="read:jobs">
                    <JobBoard />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/projects/board"
              element={
                <Protected>
                  <RequirePerm perm="read:jobs">
                    <JobBoard boardOnly />
                  </RequirePerm>
                </Protected>
              }
            />
            <Route
              path="/projects/schedule"
              element={
                <Protected>
                  <JobSchedule />
                </Protected>
              }
            />
            <Route
              path="/projects/team-load"
              element={
                <Protected>
                  <TeamLoad />
                </Protected>
              }
            />
            <Route
              path="/projects/service"
              element={
                <Protected>
                  <ServiceCalls />
                </Protected>
              }
            />
            <Route
              path="/projects/service/new"
              element={
                <Protected>
                  <ServiceCallForm />
                </Protected>
              }
            />
            <Route
              path="/projects/service/:id/edit"
              element={
                <Protected>
                  <ServiceCallForm />
                </Protected>
              }
            />
            <Route
              path="/projects/today"
              element={
                <Protected>
                  <MyDay />
                </Protected>
              }
            />
            <Route
              path="/projects/day-sheet"
              element={
                <Protected>
                  <CrewDaySheet />
                </Protected>
              }
            />
            <Route
              path="/projects/new"
              element={
                <Protected>
                  <JobForm />
                </Protected>
              }
            />
            <Route
              path="/jobs/*"
              element={<JobsToProjects />}
            />
            <Route
              path="/projects/:id/packet"
              element={
                <Protected>
                  <JobPacket />
                </Protected>
              }
            />
            <Route
              path="/projects/:id/label"
              element={
                <Protected>
                  <InstallLabel />
                </Protected>
              }
            />
            <Route
              path="/projects/:id/edit"
              element={
                <Protected>
                  <JobForm />
                </Protected>
              }
            />
            <Route
              path="/account"
              element={
                <Protected>
                  <Account />
                </Protected>
              }
            />
            <Route
              path="/inbox"
              element={
                <Protected>
                  <Inbox />
                </Protected>
              }
            />
            <Route
              path="/inbox/:tab"
              element={
                <Protected>
                  <Inbox />
                </Protected>
              }
            />
            <Route
              path="/mobile"
              element={
                <Protected>
                  <MobileShell />
                </Protected>
              }
            >
              <Route
                index
                element={<Navigate to="/mobile/day" replace />}
              />
              <Route path="calendar" element={<MobileCalendar />} />
              <Route path="day" element={<MobileMyDay />} />
              <Route path="map" element={<MobileMap />} />
              <Route path="stock" element={<MobileStock />} />
              <Route path="bills" element={<MobileBills />} />
              <Route path="accounts" element={<MobileAccounts />} />
              <Route path="settings" element={<MobileSettings />} />
              <Route path="messages" element={<MobileMessages />} />
              <Route path="jobs/:id" element={<MobileJob />} />
              <Route path="service/:id" element={<MobileService />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" position="bottom-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

function PublicApp() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SiteHome />} />
          <Route path="/services" element={<SiteServices />} />
          <Route
            path="/trade"
            element={<Navigate to="/trade/multi-family-commercial" replace />}
          />
          <Route
            path="/trade/multi-family-commercial"
            element={<SiteTrade />}
          />
          <Route path="/trade/designers" element={<SiteDesigners />} />
          <Route path="/trade/contractors" element={<SiteContractors />} />
          <Route
            path="/collections"
            element={<Navigate to="/collections/material/edges" replace />}
          />
          <Route
            path="/collections/material"
            element={<Navigate to="/collections/material/edges" replace />}
          />
          <Route path="/collections/material/edges" element={<SiteEdges />} />
          <Route
            path="/collections/brands/:slug"
            element={<SiteBrand />}
          />
          <Route path="/brands/:slug" element={<SiteBrandStock />} />
          <Route path="/po/confirm/:token" element={<SupplierPoConfirm />} />
          <Route path="/book/viewing/:token" element={<BookViewing />} />
          <Route path="/confirm/fixture/:token" element={<FixtureConfirm />} />
          <Route path="/choose/colour/:token" element={<ColourChoice />} />
          <Route path="/gallery" element={<SiteGallery />} />
          <Route path="/gallery/:id" element={<SiteProject />} />
          <Route path="/about" element={<SiteAbout />} />
          <Route path="/contact" element={<SiteContact />} />
          <Route path="/resources" element={<SiteResources />} />
          <Route path="/terms" element={<SiteTerms />} />
          <Route path="/privacy" element={<SitePrivacy />} />
          <Route path="/display" element={<ShowroomDisplay />} />
          <Route path="/inventory" element={<PublicShowroom />} />
          <Route path="/inventory/:key" element={<PublicSlabDetail />} />
          <Route path="/compare" element={<PublicCompare />} />
          <Route
            path="/showroom/public"
            element={<Navigate to="/inventory" replace />}
          />
          <Route
            path="/showroom/public/:key"
            element={<LegacyItemRedirect />}
          />
          <Route path="/leads/new" element={<LeadForm />} />
          <Route path="/share/:token" element={<SharePage />} />
          <Route path="/portal" element={<PortalLogin />} />
          <Route path="/portal/enter/:token" element={<PortalEnter />} />
          <Route path="/portal/home" element={<PortalHome />} />
          <Route
            path="/portal/projects"
            element={<PortalList kind="projects" />}
          />
          <Route path="/portal/quotes" element={<PortalList kind="quotes" />} />
          <Route path="/portal/jobs" element={<PortalList kind="jobs" />} />
          <Route
            path="/portal/invoices"
            element={<PortalList kind="invoices" />}
          />
          <Route path="/portal/inventory" element={<PortalInventory />} />
          <Route path="/portal/inventory/:slug" element={<PortalInventoryItem />} />
          <Route path="/portal/sinks" element={<PortalSinks />} />
          <Route path="/portal/sinks/:slug" element={<PortalSinkItem />} />
          <Route path="/portal/reservations" element={<PortalReservations />} />
          <Route path="/portal/request" element={<PortalRequestQuote />} />
          <Route path="/portal/projects/:id" element={<PortalProject />} />
          <Route path="/portal/quotes/:id" element={<PortalQuote />} />
          <Route path="/portal/jobs/:id" element={<PortalJob />} />
          <Route path="/portal/invoices/:id" element={<PortalInvoice />} />
          <Route
            path="/portal/payment/success"
            element={<PortalPaymentReturn />}
          />
          <Route
            path="/portal/payment/cancel"
            element={<PortalPaymentReturn cancelled />}
          />
          {CRM_SEGMENTS.map((seg) => (
            <Route key={seg} path={`/${seg}/*`} element={<AdminRedirect />} />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster theme="dark" position="bottom-center" />
      </BrowserRouter>
    </div>
  );
}
